import { ArrowForwardIos, ContentCopy, Delete, LinkOff, ViewWeek } from "@mui/icons-material";
import React, { memo } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  return (
    <div style={{ backgroundColor: "#fff", padding: "8px", borderRadius: "8px", boxShadow: "rgba(0,0,0,0.05) 0px 3px 5px", border: "1px solid rgba(99,102,241,0.35)", minWidth: 180 }}>
      <Handle type="target" position="left" style={{ background: "#6366F1", width: "18px", height: "18px", top: "20px", left: "-12px", cursor: "pointer" }} isConnectable={isConnectable}>
        <ArrowForwardIos sx={{ color: "#fff", width: "10px", height: "10px", marginLeft: "2.9px", marginBottom: "1px", pointerEvents: "none" }} />
      </Handle>
      <div style={{ display: "flex", position: "absolute", right: 5, top: 5, cursor: "pointer", gap: 6 }}>
        <ContentCopy onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("duplicate"); }} sx={{ width: "12px", height: "12px", color: "#F7953B" }} />
        <LinkOff onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("disconnect"); }} sx={{ width: "12px", height: "12px", color: "#F7953B" }} />
        <Delete onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("delete"); }} sx={{ width: "12px", height: "12px", color: "#F7953B" }} />
      </div>
      <div style={{ color: "#6366F1", fontSize: "14px", fontWeight: 700, display: "flex", alignItems: "center", gap: 4, marginBottom: 6 }}>
        <ViewWeek sx={{ width: "14px", height: "14px" }} />
        Adicionar Kanban
      </div>
      <div style={{ background: "rgba(99,102,241,0.08)", borderRadius: 6, padding: "4px 8px", fontSize: 11, color: "#4338CA", fontWeight: 600, textAlign: "center" }}>
        {data?.tag?.name || "Selecione lane..."}
      </div>
      <Handle type="source" position="right" id="a" style={{ background: "#6366F1", width: "18px", height: "18px", top: "70%", right: "-11px", cursor: "pointer" }} isConnectable={isConnectable}>
        <ArrowForwardIos sx={{ color: "#fff", width: "10px", height: "10px", marginLeft: "2.9px", marginBottom: "1px", pointerEvents: "none" }} />
      </Handle>
    </div>
  );
});
